"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcPreviewRectangle = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.8001 3.19988H3.20012V16.7999H16.8001V3.19988ZM2.00012 1.99988V17.9999H18.0001V1.99988H2.00012Z" }) })));
exports.default = IcPreviewRectangle;
